import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Button, Menu } from 'react-aria-menubutton';
import classnames from 'classnames';

import ClockIcon from 'Components/icons/ClockIcon';
import MenuItemElements from './MenuItemElements';
import './SelectInput.scss';

const SelectInput = ({
  isAppSelection,
  dataList,
  handleSelection,
  selectedItem,
  promptText,
  wrapperClass,
  extraClass,
  isDisabled,
  label,
  name,
  id,
  type,
  menuHeaderTitle,
  showScheduleList,
  labelTooltip,
  translations,
  classExtension,
  promptOnly,
  selectClass,
  shortCutAvailable,
  toggleFilterPane,
  isArchiveImage,
  optionTextWrapCssClass,
  addNegativeMargin,
  isReadOnly,
  elementStyle,
  isReadOnlyGreyDisable,
  disableClick,
  removeFilterAction,
  updatedId,
  showDynamicFilter,
  extraSpanClass,
  doclabelClass,
  filterErrorMsg,
  reportName
}) => {
  const isActivated = selectedItem && selectedItem.value === 'activated';
  const isDeactivated = selectedItem && selectedItem.value === 'deactivated';
  const isPending = selectedItem && selectedItem.value === 'pending-invite';

  // initCommonTranslate(); @TODO

  const translateOptions = {
    // @TODO revisit translations with counterpart
    // edit: counterpart('globalTranslate.common.edit'),
    // delete: counterpart('globalTranslate.common.delete'),
    edit: 'edit',
    delete: 'delete',
  };

  function getHtmlizedItem(item) {
    const acquirerCode = JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode;
    const activationClasses = classnames('header-text-'+acquirerCode, {
      'is-badge': isActivated || isDeactivated,
      'is-activated': isActivated && selectedItem.value === item.toLowerCase(),
      'is-deactivated':
        isDeactivated && selectedItem.value === item.toLowerCase(),
        'disable-dropdown': isReadOnlyGreyDisable,
        'no-click': disableClick,
    });

    return (
      <span
        className={activationClasses}
        dangerouslySetInnerHTML={{ __html: item }} // eslint-disable-line react/no-danger
      />
    );
  }

  const classNames = classnames(`select-menu ${wrapperClass}`,
    `${classExtension}`, {
      [`${extraClass}`]: extraClass,
      'is-disabled': isDisabled,
    });

  const menuTriggerClasses = classnames(`dropdown-menu-trigger`, `${classExtension }`, {
    'is-badge': isActivated || isDeactivated,
    activated: isActivated,
    deactivated: isDeactivated,
    pending: isPending,
    'is-disabled': isDisabled,
    'disable-dropdown': isReadOnlyGreyDisable,
    'no-click': disableClick,
    
  });

  const selectMenuOptionsContainer = classnames('select-menu-options', {
    'include-head': menuHeaderTitle !== '',


  });

  const promptTextWithIcon = classnames('', {
    'schedule-list': showScheduleList,
  });
  const lockedCaseClasses = classnames('locked-case-menu', `${classExtension}`, {
    'is-disabled': isReadOnly,
  });

  const mainHeader = isAppSelection ? { marginTop: '8px' } : addNegativeMargin ? { marginTop: '-16px' } : { marginTop: '0px' };

const labelContent = (<span className="label-style">
<label htmlFor={`${label}`} className="field-label"><span className={extraSpanClass}>{label}</span></label>

{labelTooltip}
{showDynamicFilter &&<div role='button' className="clear-filters" style={{cursor:"pointer",marginTop:"-3px",float:"left"}}
 onClick={() => removeFilterAction(updatedId)}>
<span>&nbsp;&nbsp;<u>remove</u></span>
</div>  }
{reportName === 'MRE' && filterErrorMsg && <span style={{ "color": "red", fontFamily: 'Roboto',fontStyle: "normal",fontWeight: 400,fontSize: "11px",marginLeft:"8px" }}>{filterErrorMsg}</span>}
</span>);
  return (
    <Wrapper className={classNames} onSelection={handleSelection} style = {reportName === 'MRE' && isDisabled ? {"cursor":"not-allowed"} : {}}>
      {label !== ''
        ? labelContent
        : ''
      }
      {isReadOnly?
      <Button
      id={`${id}`}
      className={lockedCaseClasses}
      disabled={isDisabled}
    > {promptText}
    </Button>
      :
      <Button
        id={`${id}`}
        className={menuTriggerClasses}
        disabled={isDisabled}
        style={{ border: filterErrorMsg && reportName == 'MRE' ? "1px solid red" : '', marginTop : reportName == 'MRE' &&  name == 'mre_cmp_dspt_amt' ? "24px" : "", whiteSpace : reportName == 'MRE' ? 'nowrap' : ''}}
        
      >
        {promptOnly ? (<div className={promptTextWithIcon} >
          {showScheduleList ? <ClockIcon /> : ''}
          {getHtmlizedItem(promptText)
          }
        </div>) : type === 'withIcon' ? (
          <div>
            <b style={{ color: 'gray' }}>{translations.viewing} </b>
            {selectedItem.text}
          </div>
        ) : (<div className={classnames(promptTextWithIcon, optionTextWrapCssClass)} style={elementStyle?elementStyle: promptText && promptText.includes('Zoom') ? { width: '90px' } : {}} >
          {showScheduleList ? <ClockIcon /> : ''}
          {selectedItem && selectedItem.text !== ''
            ? getHtmlizedItem(selectedItem.text)
            : promptText
          }
        </div>)}
      </Button>}
      <Menu >
        <ul className={selectMenuOptionsContainer} style={{ ...selectClass, ...mainHeader, }}>
          {menuHeaderTitle !== '' &&
            <li className="menu-header">
              {menuHeaderTitle}
              {/* <span>+</span> */}
            </li>
          }
          <MenuItemElements
            doclabelClass={doclabelClass}
            dataList={dataList}
            name={name}
            selectedItem={selectedItem}
            type={type}
            options={showScheduleList}
            translations={translateOptions}
            shortCutAvailable={shortCutAvailable}
            isArchiveImage={isArchiveImage}
          />
        </ul>
      </Menu>
    </Wrapper>
  );
};

SelectInput.propTypes = {
  dataList: PropTypes.array.isRequired,
  handleSelection: PropTypes.func.isRequired,
  promptText: PropTypes.string,
  selectedItem: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    text: PropTypes.string,
  }),
  wrapperClass: PropTypes.string.isRequired,
  classExtension: PropTypes.string,
  extraClass: PropTypes.string,
  isDisabled: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  id: PropTypes.string,
  type: PropTypes.string,
  showScheduleList: PropTypes.bool,
  menuHeaderTitle: PropTypes.string,
  labelTooltip: PropTypes.object,
  translations: PropTypes.object,
  isAppSelection: PropTypes.bool,
  toggleActionPane: PropTypes.func,
  isArchiveImage: PropTypes.bool,
  optionTextWrapCssClass: PropTypes.string,
  addNegativeMargin: PropTypes.bool,
};

SelectInput.defaultProps = {
  promptText: 'Choose one',
  selectedItem: undefined,
  extraClass: '',
  isDisabled: false,
  label: '',
  name: 0,
  id: '',
  type: '',
  showScheduleList: false,
  menuHeaderTitle: '',
  labelTooltip: null,
  translations: {},
  classExtension: '',
  selectClass: '',
  isAppSelection: false,
  toggleFilterPane: () => {},
  isArchiveImage: false,
  optionTextWrapCssClass: '',
  addNegativeMargin: false,
  elementStyle:undefined,
  isReadOnlyGreyDisable: false,
  disableClick: false,
  doclabelClass: '',
};

export function findItem(list, selectedValue) {
  return list.find((item) => item.value === selectedValue);
}


export default SelectInput;